import React from 'react'
import TitleWithMenuIcon from '../components/typography/TitleWithMenuIcon'

function Manualistica() {
  return (
    <TitleWithMenuIcon label="Manualistica" />
  )
}

export default Manualistica